import axios from 'axios'
import applyInterceptors from './interceptors'
import { API_URL } from 'constants/env'

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

applyInterceptors(api)

export default api